import type { Area, AreaListItem } from "@/areas/types";
import { apiClient } from "./apiClient";

export const areasGateway = {
  async listAreas(): Promise<Array<AreaListItem>> {
    return await apiClient.get("/api/areas");
  },

  async getArea(id: string): Promise<Area> {
    return await apiClient.get(`/api/areas/${id}`);
  },

  async createArea(area: Area): Promise<Area> {
    return await apiClient.post("/api/areas", area);
  },

  async updateArea(area: Area): Promise<Area> {
    return await apiClient.put(`/api/areas/${area.id}`, area);
  },

  async deleteArea(area: Area): Promise<void> {
    return await apiClient.delete(`/api/areas/${area.id}`);
  },
};
